/** 聚意宝 **/
import CpsService from '@/service/CpsCreate'
const cpsService = new CpsService();

/** 营销中心 **/
import MarketService from '@/service/Market'
const marketService = new MarketService();

/** 营销中心 **/
import UserService from '@/service/User'
const userService = new UserService();

/** 发票 **/
import InvoiceService from '@/service/Invoice'
const invoiceService = new InvoiceService();

/** 红包 */
import RedpacketService from '@/service/Redpacket'
const redpacketService = new RedpacketService();

/** 带客金 **/
import VirtualCurrencyService from '@/service/VirtualCurrency'
const virtualCurrencyService = new VirtualCurrencyService();

/**钱包 */
import WalletService from '@/service/Wallet'
const walletService = new WalletService();

/**推广 */
import ExtensionService from '@/service/Extension';
const extensionService = new ExtensionService();
/** 服务类推广 */
import ServicePromotion from '@/service/ServicePromotion'
const servicePromotion = new ServicePromotion();
/**高峰日 */
import PeakDaySettingService from '@/service/PeakDaySetting'
const peakDaySettingService = new PeakDaySettingService();
/**首页**/
import HomeService from '@/service/Home'
const homeService = new HomeService();
/**通知**/
import AdNoticeService from '@/service/AdNotice'
const adNoticeService = new AdNoticeService();

import FreeRoomApplyOrderService from './FreeRoomApplyOrder';
const freeRoomApplyOrderService = new FreeRoomApplyOrderService();

import ChengStarOrderService from './ChengStarOrder';
const chengStarOrderService = new ChengStarOrderService();

import ChengStarSalesDistributionService from './ChengStarSalesDistribution';
const chengStarSalesDistributionService = new ChengStarSalesDistributionService();

import CampaignInsuranceService from './CampaignInsurance';
const campaignInsuranceService = new CampaignInsuranceService();

export {
    campaignInsuranceService,
    chengStarOrderService,
    chengStarSalesDistributionService,
    freeRoomApplyOrderService,
    cpsService,
    marketService,
    userService,
    invoiceService,
    redpacketService,
    virtualCurrencyService,
    walletService,
    extensionService,
    servicePromotion,
    peakDaySettingService,
    homeService,
    adNoticeService,
}